export default "__VITE_ASSET__BRuIjRbI__"